import querystring from 'querystring'
import HTTP from '@/utils/http'
import notification from '@/utils/notification'
import { save } from '@/utils/xfs'

export async function exportEmergency (query) {
  const params = $.param(query)
  const response = await HTTP.get(`ccdcontacts/export-emergency?${params}`, { responseType: 'arraybuffer' })
  save(response)
}

export async function exportMarketing () {
  try {
    const response = await HTTP.get('ccdcontacts/export-marketing', { responseType: 'arraybuffer' })
    save(response)
  } catch (err) {
    notification.handleResponseError(err, 'exportContact')
    throw err
  }
}

export async function exportFireMarshal (params) {
  try {
    const response = await HTTP.post(`ccdcontacts/export-fire-marshal`, params, { responseType: 'arraybuffer' })
    save(response)
  } catch (err) {
    notification.handleResponseError(err, 'exportContact')
    throw err
  }
}

export async function getAdvanceResults (query, options = { raw: false }) {
  const { data } = await HTTP.get(`ccdcontacts/search`, { params: query })
  const opts = Object.assign({ raw: false }, options)
  return data && (opts.raw ? data : data.data)
}

export async function getContact (contactId) {
  try {
    const response = await HTTP.get(`ccdcontacts/${contactId}`)
    const contact = response.data.data
    return contact
  } catch (err) {
    notification.handleResponseError(err, 'getContact')
  }
}

export async function listContacts (query) {
  try {
    const params = querystring.stringify(query)
    const response = await HTTP.get(`ccdcontacts?${params}`)
    const contact = response.data.data
    return contact
  } catch (err) {
    notification.handleResponseError(err, 'getContact')
  }
}

export async function getCompanyContacts (companyId) {
  try {
    const response = await HTTP.get(`ccdcontacts/?companyId=${companyId}`)
    const contact = response.data.data
    return contact
  } catch (err) {
    notification.handleResponseError(err, 'getContact')
  }
}

export async function createContact (request) {
  try {
    const response = await HTTP.post('ccdcontacts', {...request})
    const contact = response.data.data
    return contact
  } catch (err) {
    notification.handleResponseError(err, 'createContact')
  }
}

export async function updateContact (contactId, request) {
  try {
    delete request.id
    delete request.createdAt
    delete request.updatedAt
    await HTTP.put(`ccdcontacts/${contactId}`, request)
    return true
  } catch (err) {
    notification.handleResponseError(err, 'updateContact')
    return false
  }
}
